import { useMemo } from 'react';

import { UserOutlined } from '@ant-design/icons';

import { useAuthState } from '@contexts/auth/AuthContext';
import ROUTES from '@data/staticRoutes.json';
import { MobileLogoutButton, LogoutButton } from '@shared';
import { useBreakpoint } from '@contexts/breakpoints';

import { FlexDirectionRow, Item } from './styled';
import { Rectangle } from '../../bottomHeader/styled';

const UserMenu = () => {
  const {
    userInfo: { firstName, lastName, totalRewardAmount },
  } = useAuthState();

  const { xl } = useBreakpoint();

  const profileName = useMemo(
    () => (firstName || lastName ? `${firstName} ${lastName}` : ''),
    [firstName, lastName]
  );

  if (profileName) {
    return (
      <>
        {xl ? (
          <LogoutButton
            fullName={profileName}
            totalMileAmount={totalRewardAmount}
          />
        ) : (
          <MobileLogoutButton
            fullName={profileName}
            totalMileAmount={totalRewardAmount}
          />
        )}
      </>
    );
  }

  return (
    <>
      <Item prefetch={false} href={ROUTES.ssoLogin}>
        <FlexDirectionRow>
          <UserOutlined />
          <span> Giriş Yap</span>
        </FlexDirectionRow>
      </Item>

      <Rectangle />

      <Item prefetch={false} href={ROUTES.ssoSignUp}>
        Üye Ol
      </Item>
    </>
  );
};

export default UserMenu;
